module.exports = __webpack_public_path__ + "img/hppc_dark_logo.4369fb38.svg";